import { resolveURL } from 'src/utils/ipfs';
import Image from 'src/components/image';

export default function IPFSImage({ src, sx, ...other }) {
  const resource = resolveURL(src);
  return <Image src={resource} sx={sx} />;
}
